export const OPEN_FOLDER_ON_ENTER_APP = 'open-folder-on-enter-app';
